import { RaffleMetaData } from '../lib/types';
import { TESTING } from './misc';

// HbwUf4Lhc5a7QEdeGxBR7N9ZgHrokajoeQvsvL9ZND12 - can be used later
const testWhitelist = new Map<string, RaffleMetaData>([
	[
		'3eSWPV2tbPzn7Mhw2piLyDGAMQRPr4TMsrfuUzRouPrC',
		{
			name: 'PENGSOL Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/pengsol_wl.png',
			twitter: 'https://twitter.com/pengsol_',
			discord: 'https://discord.com/creckhouse',
			description: '25 winners will receive 1 WL spot for PENGSOL upcoming NFT project (Discord Closed)',
			total: 5000,
			claimable: false,
			timer: 'Tuesday, 11 June 2022 06:30:00 PM GMT+05:30',
		},
	],
	[
		'NvtQ4Ss7QPrPE586kYheVWTiQVRBkkSAVvET4iJ6ENo',
		{
			name: 'Neo Hunters Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/neo_hunters.jpg',
			twitter: 'https://twitter.com/neo_hunters',
			discord: 'http://discord.gg/neohunters',
			description: '20 winners will receive 1 WL spot for Neo Hunters upcoming NFT project',
			total: 5000,
			claimable: false,
			timer: 'Tuesday, 10 June 2022 06:30:00 PM GMT+05:30',
		},
	],
	[
		'6YBzEYCyBfEioY1wUnX4UcFuGXGZEKgjCeDyvbo7voua',
		{
			name: 'Degen Sweepers Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/degen_sweepers.png',
			twitter: 'https://twitter.com/DegenSweepers',
			discord: 'https://discord.gg/degensweepers',
			description: '100 winners will receive 1 WL spot for Degen Sweepers upcoming NFT project',
			total: 5000,
			claimable: false,
			timer: 'Tuesday, 7 June 2022 06:30:00 PM GMT+05:30',
		},
	],
	[
		'HKoxopgKLNzBsjAEqA5pmuWDVNjALNPb6gHdbnFowvck',
		{
			name: 'Saint Skully Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/skeleton.png',
			twitter: 'https://twitter.com/SaintSkullyNFT',
			discord: 'https://discord.gg/saintskully',
			description: '40 winners will receive 1 WL spot for Saint Skully upcoming NFT project',
			total: 5000,
			claimable: false,
			timer: 'Sunday, 5 June 2022 06:30:00 AM GMT+05:30',
		},
	],
	[
		'5RHJ44A8y5xmgnCFG4UhSrMRA3aN988bDi5UPf3nD4J5',
		{
			name: 'PRIMATES Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/primates.png',
			twitter: 'https://twitter.com/Primatesnft',
			discord: 'https://discord.gg/theprimates',
			description: '20 winners will receive 1 WL spot for PRIMATES upcoming NFT project',
			total: 5000,
			claimable: false,
			timer: 'Wednesday, 1 June 2022 6:30:00 PM GMT+05:30',
		},
	],
	[
		'2jBuTQPyaB2NnKjFrHaFgHo1g9xw5srfvFQsNdwrgALJ',
		{
			name: 'Bubblegoose Ballers Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/bubblegoose.jpeg',
			twitter: 'https://twitter.com/BubblegooseXYZ',
			discord: 'https://www.bubblegooseballers.xyz/',
			description: '40 winners will receive 1 WL spot for Bubblegoose Ballers upcoming NFT project',
			total: 5000,
			claimable: false,
			timer: 'Saturday, 23 April 2022 4:00:00 PM GMT+05:30',
		},
	],
	[
		'GDWJbxqvsoJxupSgFSqY6UszFFSu3dteBh2pTnLPhF6H',
		{
			name: 'Shrouded Playground Whitelist',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/shrouded.jpg',
			twitter: 'https://mobile.twitter.com/ShroudedNFT',
			discord: 'https://discord.com/invite/dMdaUBgG2Q',
			description: 'Winners will receive Shrouded Playground Whitelist! Good luck cets!',
			total: 5000,
			claimable: false,
			timer: 'Saturday, 23 April 2022 4:00:00 PM GMT+05:30',
		},
	],	
	[
		'9B8W3K9Vq1gUkqwxTVHPWWhxx5iJPkFQKVp7VEpTZTSX',
		{
			name: '#CetsCare fundraiser',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/cetscharity.jpg',
			twitter: 'https://twitter.com/CetsOnCreck',
			discord: 'https://discord.gg/creckhouse',
			description: 'Winners will receive 2 Okay bears and 1 Cet',
			total: 5000,
			claimable: true
		},
	],
	[
		'9Ws4Bhi7wzA2TuWm8LC94M1wkgxF4YvcEtcqXAx3ozT1',
		{
			name: 'Communi3: Mad Scientists',
			overviewImageUri: 'https://stek.cetsoncreck.com/api/static/raffle/communi3_raffle.jpeg',
			twitter: 'https://twitter.com/communi3_io',
			discord: 'http://discord.gg/communi3',
			description: 'Winners will receive Communi3 Mad Scientists! Good luck cets!',
			total: 5000,
			claimable: true
		},
	],
	[
		'7kCwJykmX15Jpq9DKVuVG1Ms8ddqiHnTLXDm4pyEV7CK',
		{
			name: 'Mindfolk Pirates',
			overviewImageUri:
				'https://stek.cetsoncreck.com/api/static/raffle/mindfolk_pirates.png',
			twitter: 'https://twitter.com/mindfolkART',
			discord: 'https://discord.com/invite/zsMxCZxYKw',
			description: 'Winners will receive Mindfolk Pirates! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],
	// [
	// 	'DppYVf41euGX1x6oDXB88gMKqVLN27gwJ1sZVVg8jui2',
	// 	{
	// 		name: 'WL Test',
	// 		overviewImageUri: 'https://metadata.degods.com/g/8351.png',
	// 		twitter: 'https://twitter.com/degodsnft',
	// 		discord: 'http://discord.gg/dedao',
	// 		description: 'Winner will receive this DeGod! Good luck cets!',
	// 		total: 10,
	// 		claimable: false,
	// 		timer: 'Saturday, 23 April 2022 4:00:00 PM GMT+05:30',
	// 	},
	// ],
	[
		'8P5beh4LsoURPvHCEtPyKQTv6iRLj9tBPafgPJNqcwfg',
		{
			name: 'DeGod #8359',
			overviewImageUri: 'https://metadata.degods.com/g/8358.png',
			twitter: 'https://twitter.com/degodsnft',
			discord: 'http://discord.gg/dedao',
			description: 'Winner will receive this DeGod! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],
	[
		'D1DuGDwu451kUPqMBxPVqUy1pVV3YoQQkhofpfK9CeCD',
		{
			name: 'SMB #4737',
			overviewImageUri:
				'https://arweave.net/7En-exGeDtQ4yElS5kZCyuOrkpb5ieg7uwH60uwhfPM',
			twitter: 'https://twitter.com/SolanaMBS',
			discord: 'http://discord.gg/solanamonkey',
			description: 'Winner will receive this SMB! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],
	[
		'CPkyym9DAPfXMv8jkLe7dddWHQC3wV6p21mztUYAaDfg',
		{
			name: 'Test Raffle #1',
			overviewImageUri:
				'https://arweave.net/7En-exGeDtQ4yElS5kZCyuOrkpb5ieg7uwH60uwhfPM',
			twitter: 'https://twitter.com/SolanaMBS',
			discord: 'http://discord.gg/solanamonkey',
			description: 'Winner will receive this SMB! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],
	[
		'BKjkq163EDWLhh5mSAeaVsGMQWj315HLVB7LFPeNFJWe',
		{
			name: 'Test Raffle #2',
			overviewImageUri:
				'https://arweave.net/7En-exGeDtQ4yElS5kZCyuOrkpb5ieg7uwH60uwhfPM',
			twitter: 'https://twitter.com/SolanaMBS',
			discord: 'http://discord.gg/solanamonkey',
			description: 'Winner will receive this SMB! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],
	[
		'H32nTRRyLvsSbEh4up57vfNeLkS2tveGNdfBZ6LVCY1L',
		{
			name: 'Test Raffle USDC #1',
			overviewImageUri: 'https://metadata.degods.com/g/8358.png',
			twitter: 'https://twitter.com/degodsnft',
			discord: 'http://discord.gg/dedao',
			description: 'Winner will receive this DeGod! Good luck cets!',
			total: 5000,
			claimable: true,
		},
	],

	// mainnet test mods
	// [
	// 	'ATUYgxo8uey9BwTCmZYTjWwHnLjw9xE7FmSpLnjpQAFc',
	// 	{
	// 		name: 'OG WL',
	// 		overviewImageUri:
	// 			'https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/CoCrfJfccDLXxdd4HSVynLGKavvBPPHjJEGphwXZTFyn/logo.png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 		description: 'OG WL Token',
	// 		total: 50,
	// 	},
	// ],
	// [
	// 	'2MgT5dRjT3jL4aBMip4kXskyDQpURAg5kZA7f36bZzfg',
	// 	{
	// 		name: 'Pessies #9',
	// 		overviewImageUri:
	// 			'https://www.arweave.net/6KpoAWbDz0iVJlTkBlqcQvyA9AEZbNSpgCDrOwpYdRk?ext=png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 		description: 'Get then Pessies',
	// 		total: 100,
	// 	},
	// ],
	// [
	// 	'4PiYPhqn62WGhDSHJzHAC5HtBAQ4JfhtwBUX3zdEfX1c',
	// 	{
	// 		name: 'Pessies #4',
	// 		overviewImageUri:
	// 			'https://www.arweave.net/BiDVJxaGBEktY6Mb5QFfxusEqOYCl4qRzXAQOjStSCQ?ext=png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 		description: 'Get then Pessies',
	// 		total: 100,
	// 	},
	// ],
	// mainnet test 1
	// [
	// 	'BBdmRmBNhagy27PTAYidssXsBysZsVbp6eqa4TLozuoP',
	// 	{
	// 		name: 'Pessies #4',
	// 		overviewImageUri:
	// 			'https://www.arweave.net/4zza871IiS0VpVm0VsvNKjsjo_Ex2vAPZpPmyLIJz28?ext=png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 		description: 'This is a test pessie',
	// 	},
	// ],
	// [
	// 	'EenFZr15GmX5x3BAcDWF46THYja4Usq3XARR8RUhLUtZ',
	// 	{
	// 		name: 'Pessies #1',
	// 		overviewImageUri:
	// 			'https://www.arweave.net/fGhluePTy2dg6E_d0ai3pejE4Znt04sSXptl8PbS96Q?ext=png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 		description: 'This is another test pessie',
	// 	},
	// ],
	// [
	// 	'DnmfNqH5ZDiV7Gd6BzcPk6CXhqY9cYvmVkFY2gemQZHT',
	// 	{
	// 		name: 'Pessies #3',
	// 		overviewImageUri:
	// 			'https://www.arweave.net/LZSNUAaDaucDfh5TFeVAMGfm9xnkq6g5Ika4kEFE9hw?ext=png',
	// 		twitter: 'https://twitter.com/CetsOnCreck',
	// 		discord: 'https://discord.com/invite/creckhouse',
	// 	},
	// ],
	[
		'3FC4i5AqnAnY8wymjkoxWscKbUVsBvegmDSRnSdLzLuK',
		{
			name: 'dRafflenet #1',
			overviewImageUri:
				'https://ik.imagekit.io/cmjffa5th3u/default-image.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1648752044409',
			twitter: 'https://twitter.com/CetsOnCreck',
			discord: 'https://discord.com/invite/creckhouse',
		},
	],
	[
		'B7ZJ8z1ch37CjjJn838xqKcp7ooAoUmtr4STN9HT6iot',
		{
			name: 'Raffle #2',
			overviewImageUri:
				'https://ik.imagekit.io/cmjffa5th3u/default-image.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1648752044409',
			twitter: 'https://twitter.com/CetsOnCreck',
			discord: 'https://discord.com/invite/creckhouse',
		},
	],
	[
		'7xHAJK2YfL9dPG4FTKau297c2Dcxiz6WAZTn2WNXzF3t',
		{
			name: 'Raffle #3',
			overviewImageUri:
				'https://ik.imagekit.io/cmjffa5th3u/default-image.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1648752044409',
		},
	],
	[
		'EdmGrziqDSzSdyUgVRkQL5M48RgrdByazD4fDQix66As',
		{
			name: 'Raffle #3 | SMB - 3',
			overviewImageUri:
				'https://ik.imagekit.io/cmjffa5th3u/smb3_GE0vhGPQK.png?ik-sdk-version=javascript-1.4.3&updatedAt=1649131783173',
		},
	],
	[
		'CKe4w2VvJbTGVbWppMHWDGubyA1gihC9gEhQWh88sK6A',
		{
			name: 'Raffle #4 | SMB - 32',
			overviewImageUri:
				'https://ik.imagekit.io/cmjffa5th3u/smb32_NcJ8qpdIo.png?ik-sdk-version=javascript-1.4.3&updatedAt=1649135487141',
		},
	],
]);

const prodWhitelist = new Map<string, RaffleMetaData>([
	[
		'FnHwnXGBz7NRZEsT8u12pE2cxURt8mYHQZykzmRtjb27',
		{
			name: 'dRaffle launch raffle',
			overviewImageUri: '/resources/001-mainnet-launch.gif',
		},
	],
	[
		'2QjkshNu3mrcCnriekTpppa3PFwnAR9Yf7v5vc54m2Yh',
		{
			name: 'First SOL raffle',
			overviewImageUri: '/resources/solana-logo.gif',
		},
	],
	[
		'8aEm1MoDqkYT5vCB21jC6aMMcMbdQJgmHpyBbtHDfUjU',
		{
			name: 'Anti Artist Club',
			overviewImageUri: '/resources/aartist-raffle-overview.gif',
		},
	],
	[
		'2ziwAj4awgvNyn8ywwjkBRkBsmv259u9vVyEdrGYTb54',
		{
			name: 'More SOL',
			overviewImageUri: '/resources/solana-logo.gif',
		},
	],
	[
		'EgHys3WPcM5WRpKqVHs1REfK6Npzq9sJ7dZPFPzQy2xG',
		{
			name: 'Triple SOL',
			overviewImageUri: '/resources/solana-logo-x3.gif',
		},
	],
	[
		'CjzFZfrMW4D1jZVm5upCobRi96UYnQTk5cescSt12rhV',
		{
			name: 'SAMO raffle',
			overviewImageUri: '/resources/samo-x3.gif',
		},
	],
	[
		'EZtBKgWq66KT4jRKtd4VT3LWh3mVC4pwcCsqLzKas63G',
		{
			name: 'BitBoat raffle',
			overviewImageUri: '/resources/bitboat-raffle.gif',
		},
	],
]);

export const RAFFLES_WHITELIST = TESTING ? testWhitelist : prodWhitelist;
